import { render, staticRenderFns } from "./EmergencyOnlySummary.vue?vue&type=template&id=8af41242&scoped=true"
import script from "./EmergencyOnlySummary.vue?vue&type=script&lang=js"
export * from "./EmergencyOnlySummary.vue?vue&type=script&lang=js"
import style0 from "./EmergencyOnlySummary.vue?vue&type=style&index=0&id=8af41242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af41242",
  null
  
)

export default component.exports